import R from 'app/assets/R'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import { notificationController } from 'app/controllers/notification-controller'
import { isEqual } from 'lodash'
import { ResponseType } from 'parkway-web-common'
import { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { IFormRule, IPropsUpdateMaterial } from './type'
import { IMaterial } from 'app/api/inventory/model/management'
import { requestUpdateMaterialManagement } from 'app/api/inventory'
import { MessageCode } from 'app/api/inventory/constant'

export const useModalHook = (props: IPropsUpdateMaterial) => {
  const { t } = useTranslation()
  const [form] = BaseForm.useForm<IMaterial>()
  const [visible, setVisible] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (visible) {
      form.setFieldsValue(props?.material || {})
    }
  }, [visible])

  const showModal = () => {
    setVisible(true)
  }

  const handleCancel = () => {
    setVisible(false)
    form.resetFields()
  }

  const handleSubmit = async (values: IMaterial) => {
    setIsLoading(true)
    try {
      const response: ResponseType<string> =
        await requestUpdateMaterialManagement({
          id: values?._id,
          body: { ...values, out: false },
        })

      if (isEqual(response?.msgcode, MessageCode.successPutData)) {
        setIsLoading(false)
        handleCancel()
        props?.fetchTable?.()
        notificationController.success({
          message: t(R.strings.material_import_update),
          description: t(R.strings.success),
        })
      } else {
        notificationController.error({
          message: t(R.strings.material_import_update),
          description: response?.message,
        })
      }

      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
    }
  }

  const rules: IFormRule = useMemo(() => {
    return {
      providerId: [
        {
          required: true,
          message: t(R.strings.require_field, {
            field: t(R.strings.provider),
          }),
        },
      ],
      materialCategoryId: [
        {
          required: true,
          message: t(R.strings.require_field, {
            field: t(R.strings.material),
          }),
        },
      ],
      locationId: [
        {
          required: true,
          message: t(R.strings.require_field, {
            field: t(R.strings.location),
          }),
        },
      ],
    }
  }, [t])

  return {
    form,
    visible,
    t,
    isLoading,
    showModal,
    handleSubmit,
    handleCancel,
    rules,
  }
}
